import { defineComponent as _defineComponent } from 'vue'
import { ref } from '@nuxtjs/composition-api';
import { useUser } from '~/composables/useUser';
import TInput from '~/components/atoms/t-input.vue';
import TLabel from '~/components/atoms/t-label.vue';
import TButton from '~/components/atoms/t-button.vue';
import validateEmail from '~/utils/validateEmail';


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordResetRequestForm',
  emits: ['submit'],
  setup(__props, { emit }) {

const { sendResetPasswordEmail } = useUser();

const passwordResetRequestSubmitted = ref(false);
const formError = ref('');
const formErrorEmail = ref('');
const email = ref('');


const submitResetPasswordRequest = async () => {
  formErrorEmail.value = '';
  try {
    await sendResetPasswordEmail(email.value);
  } catch (error) {
    console.log(error);
  }
  passwordResetRequestSubmitted.value = true;
  emit('submit');
};

// eslint-disable-next-line require-await
const validateUserEmail = async () => {
  formError.value = validateEmail(email.value) ? '' : 'Invalid email address.';
};

return { __sfc: true,sendResetPasswordEmail, passwordResetRequestSubmitted, formError, formErrorEmail, email, emit, submitResetPasswordRequest, validateUserEmail, TInput, TLabel, TButton }
}

})